import { Action } from '@reduxjs/toolkit';
import {
  Observable, from, of, interval,
} from 'rxjs';
import {
  switchMap, catchError, ignoreElements, filter,
} from 'rxjs/operators';

import { pingActions } from '../../actions';
import { PING_INTERVAL } from './constants';
import { selfPing } from './utils';

const { ping } = pingActions;

const pingRequestEpic = (action$: Observable<Action>) => action$.pipe(
  filter(ping.request.match),
  switchMap(() => interval(PING_INTERVAL).pipe(
    switchMap(() => from(selfPing())),
    ignoreElements(),
    catchError(() => of(ping.error()))
  ))
);

export default pingRequestEpic;
